import {createApp} from 'vue';
import router from './router'
import axios from 'axios'
import AntD, {message} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import store from './store'
import storage from './storage'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from "element-plus/es/locale/lang/zh-cn";
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//import {useRoute} from "vue-router";
import Cookies from "js-cookie";

import env from './env'
// mock开关
const mock = false;
if (mock) {
    require('./mock/api');
}
const currentURL = window.location.origin;
axios.defaults.baseURL = env.baseURL;
//axios.defaults.baseURL = '/api';
axios.defaults.timeout = 8000;
// 根据环境变量获取不同的请求地址



axios.interceptors.request.use(config => {
    //console.log(env.siteURL);
    /*config.headers['domain'] = env.domain;*/
    config.headers['domain'] = currentURL;
    config.headers['token'] = Cookies.get('token') || '';
    return config;
})

// 接口错误拦截
axios.interceptors.response.use(function (response) {
    let res = response.data;
    //console.log("res",res);
    if (res.code == 200) {
        return res;
    } else if (res.code == 103) {
        window.location.href = '/login';
        return Promise.reject(res);
    }else if (res.code == 400) {
        window.location.href = '/login';
        return Promise.reject(res);
    } else {
        message.warning(res.msg);
        //return Promise.reject(res);
    }
}, (error) => {
    console.log("error",error);
    let res = error.response;
    message.error(res.data.message);
    return Promise.reject(error);
});
const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$siteUrl = currentURL;
app.config.globalProperties.$imgUrl = env.imgURL;
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}



//const Route=useRoute();
//console.log('main',Route);

app.use(AntD)
    .use(router)
    .use(store)
    .use(storage)
    .use(ElementPlus,{locale:zhCn})
    .mount('#app')
